export default __webpack_public_path__ + "static/media/accessibility.9ad33003.svg";